// ClassEdit.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";

const ClassEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: "", coverUrl: "", file: null });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/class/${id}`)
      .then(({ data }) =>
        setForm({ title: data.title, coverUrl: data.cover || "", file: null })
      )
      .catch((err) => console.error("❌ Sınıf verisi alınamadı:", err));
  }, [id]);

  const handleChange = (e) => setForm({ ...form, title: e.target.value });
  const handleDrop = (files) => setForm({ ...form, file: files[0] });

  const handleRemovePhoto = async () => {
    if (form.file) {
      setForm({ ...form, file: null });
      return;
    }
    if (form.coverUrl) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/api/class/${id}/cover`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
        );
        toast.success("Fotoğraf silindi!");
        setForm({ ...form, coverUrl: "", file: null });
      } catch (err) {
        console.error("❌ Fotoğraf silme hatası:", err);
        toast.error("Fotoğraf silinirken hata oluştu!");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("title", form.title);
    if (form.file) data.append("cover", form.file);
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/class/${id}`,
        data,
        { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
      );
      toast.success("Güncelleme başarılı!");
      setTimeout(() => navigate("/classes/table"), 1500);
    } catch (err) {
      console.error("❌ Güncelleme hatası:", err);
      toast.error("Güncelleme başarısız oldu!");
    }
  };

  const preview =
    form.file
      ? URL.createObjectURL(form.file)
      : form.coverUrl
      ? `${process.env.REACT_APP_API_BASE_URL}${form.coverUrl}`
      : null;

  return (
    <div className="container mt-4">
      <form className="card p-4" onSubmit={handleSubmit}>
        <h5 className="mb-3 fw-bold">Sınıf Düzenle</h5>
        <div className="mb-3">
          <label className="form-label">Başlık</label>
          <input
            className="form-control"
            value={form.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Görsel</label>
          <Dropzone onDrop={handleDrop} accept={{ "image/*": [] }}>
            {({ getRootProps, getInputProps }) => (
              <div
                {...getRootProps()}
                className="border p-3 text-center"
                style={{ cursor: "pointer" }}
              >
                <input {...getInputProps()} />
                {preview ? (
                  <div>
                    <img
                      src={preview}
                      alt="preview"
                      style={{ maxHeight: 120 }}
                      className="img-thumbnail mb-2"
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemovePhoto();
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <p>Buraya sürükleyin veya tıklayın, dosya seçin.</p>
                )}
              </div>
            )}
          </Dropzone>
        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary">Kaydet</button>
        </div>
      </form>
    </div>
  );
};

export default ClassEdit;